import React from 'react';

function ManagesInvoicePage() {
    return <div>ManagesInvoicePage</div>;
}

export default ManagesInvoicePage;
